import { createTypes, completeTypes, withPostSuccess, withPostFailure } from 'redux-recompose';
import i18next from 'i18next';

import DisabledService from '~services/Disabled/service';
import Snackbar from '~app/components/@core/Snackbar';

import { menuMapper } from './mappers';

export const actions = createTypes(
  completeTypes(['GET_DISABLEDS', 'GET_PRICES', 'GET_STATIC_MENU', 'BLOCK', 'UNBLOCK']),
  '@@DISABLED'
);

export const targets = {
  DISABLEDS: 'disableds',
  PRICES: 'prices',
  BLOCK: 'block'
};

const actionCreators = {
  getDisableds: (storeId, menuId) => (dispatch, getState) => {
    const state = getState();
    const { staticMenu } = state.core.settings || {};

    dispatch({
      type: actions.GET_DISABLEDS,
      target: targets.DISABLEDS,
      payload: storeId,
      service: DisabledService.getDisableds,
      injections: [
        withPostSuccess((dispatch, { data: disabledProducts }) => {
          dispatch(
            staticMenu
              ? actionCreators.getStaticMenu(storeId, menuId, disabledProducts)
              : actionCreators.getPrices(storeId)
          );
        })
      ]
    });
  },
  getPrices: (storeId) => ({
    type: actions.GET_PRICES,
    target: targets.PRICES,
    payload: storeId,
    service: DisabledService.getPrices
  }),
  getStaticMenu: (storeId, menuId, disabledProducts) => ({
    type: actions.GET_STATIC_MENU,
    target: targets.PRICES,
    payload: menuId,
    service: DisabledService.getStaticMenu,
    successSelector: ({ data }) => {
      return menuMapper(data, disabledProducts);
    },
    injections: [
      withPostFailure((dispatch) => {
        dispatch(actionCreators.getPrices(storeId));
      })
    ]
  }),
  block: (id, type, storeId, menuId, endDate, show = true) => ({
    type: actions.BLOCK,
    target: targets.BLOCK,
    payload: { id, type, storeId, endDate, show },
    service: DisabledService.block,
    injections: [
      withPostSuccess((dispatch) => {
        dispatch(actionCreators.getDisableds(storeId, menuId));
        Snackbar.success(i18next.t('BlockConfirmationModal:success'));
      }),
      withPostFailure(() => {
        Snackbar.error(i18next.t('BlockConfirmationModal:failure'));
      })
    ]
  }),
  unBlock: (id, storeId, menuId) => ({
    type: actions.UNBLOCK,
    payload: id,
    service: DisabledService.unBlock,
    injections: [
      withPostSuccess((dispatch) => {
        dispatch(actionCreators.getDisableds(storeId, menuId));
      })
    ]
  })
};

export default actionCreators;
